import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    isVerticalMenuActive: true,
    isMobile:false
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },
    UPDATE_VERTICAL_MENU_ACTIVE(state, val) {
      state.isVerticalMenuActive = val
    },
    UPDATE_MOBILE(state, val) {
      state.isMobile = val
    }
  },
  actions: {},
}
